import React from "react";
import { useQuery } from "@tanstack/react-query";
import parse from "html-react-parser";

import { useThemeChange } from "../../../utils/themeChange";
import { useApi } from "../../../hooks/api/useApi";
import { CMS } from "../../../constants/api-constants";

const { TEMPLATES } = CMS;

const Index = () => {
  const themeChange = useThemeChange();
  const { getById } = useApi();

  const termsContent = useQuery({
    queryKey: ["terms"],
    queryFn: () => getById("TERMS_AND_CONDITIONS", TEMPLATES),
  });

  if (termsContent.isSuccess && termsContent?.data) {
    const terms_content = JSON.parse(termsContent?.data?.data);
    var content = parse(terms_content?.terms_conditions);
  }
  return (
    <div className={themeChange.add("section")}>
      <section className="container static-page-container">
        <span className="spacer-30" />
        {content ? (
          content
        ) : (
          <div className="error">
            <p>Data Unavailable. Please contact admin.</p>
          </div>
        )}
        {/* <span className="spacer-30" />
        <h2>Terms & Conditions</h2>
        <span className="spacer-30" />
        <p>Property</p>
        <p>
          As used herein the term "Property" shall mean the title, logo,
          artwork, visual representations, and other approved elements related
          to the artwork in the Agreement (and the applicable production
          cycle's, if any, specified therein). This Agreement applies to the
          specified Property only and does not include any other artwork,
          derived from, or inspired by the Property. Licensee acknowledges and
          agrees that all uses of the Property are subject to all of the terms,
          conditions, and restrictions of this Agreement.
        </p>
        <p>License</p>
        <p>
          Subject to the terms and conditions of this Agreement, Licensor hereby
          grants to Licensee, and Licensee hereby accepts, the exclusive right,
          license, and privilege to develop or have developed on its behalf, and
          to manufacture or have manufactured on its behalf, the “Licensed
          Articles” specified in the Agreement based upon the Property and the
          Artwork and to distribute, offer for sale, sell, advertise, transmit,
          display, and promote the Licensed Articles in the Territory during the
          Term . The license granted herein includes the non-exclusive right to
          use in the Territory and for the Term the title of the Property and
          the trade and service marks and names and the logos and artwork, if
          any, embodying them (collectively, the "Trademarks"). Licensee shall
          not use the Property or the Trademarks in any manner not specifically
          authorized by this Agreement. All aspects of the Licensed Articles and
          the Packaging and Promotional Materials and any on-line/web site
          activities relating to the Property, Trademarks, and Licensed Articles
          shall be subject to the approval processes and requirements and the
          other applicable provisions of this Agreement.
        </p> */}
      </section>
    </div>
  );
};

export default Index;
